import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProductSystemActions = createAsyncThunk<
    { guid: string; systemActions: any },
    { productId: string },
    ThunkConfig<string>
>('actionsSlice/fetchProductSystemActions', async (arg, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { productId } = arg

    try {
        const { data } = await api.get(
            getUrlWithVersion(`/products/${productId}/system_actions`)
        )

        return { guid: productId, systemActions: data }
    } catch (e) {
        console.error(e)
        return rejectWithValue('Failed to fetch system actions')
    }
})
